import { render, staticRenderFns } from "./ModalComments.vue?vue&type=template&id=8c9940fc&scoped=true"
import script from "./ModalComments.vue?vue&type=script&lang=js"
export * from "./ModalComments.vue?vue&type=script&lang=js"
import style0 from "./ModalComments.vue?vue&type=style&index=0&id=8c9940fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9940fc",
  null
  
)

export default component.exports